module.exports = __webpack_public_path__ + "img/lodingsb.9a331a5b.svg";